import actionTypes from "./actions/actionTypes";

const {
  REQUEST_QUESTIONNAIRES,
  RECIEVE_QUESTIONNAIRES,
  SERVER_ERROR_OCURED,
  CLEAR_ERRORS,
  REQUEST_TEMPLATES,
  RECIEVE_TEMPLATES,
  TEMPLATE_CLEAR_ERRORS,
  TEMPLATE_SERVER_ERROR_OCCURED
} = actionTypes;

const questionnaireReducer = (
  state = {
    isFetchingList: false,
    questionnaires: [],
    results: [],
    hasServerError: false,
    errors: {},
    success: false,
    isFetchingTemplates: false,
    templates: [],
    hasTemplateError: false,
    templateErrors: {},
    templatesFecthed: false
  },
  action
) => {
  switch (action.type) {
    case REQUEST_QUESTIONNAIRES:
      return Object.assign({}, state, {
        isFetchingList: true,
        hasServerError: false,
        errors: {},
        success: false,
      });
    case RECIEVE_QUESTIONNAIRES:
      return Object.assign({}, state, {
        isFetchingList: false,
        questionnaires: action.questionnaires,
        results: action.results,
        success: true,
      });
    case CLEAR_ERRORS: 
      return Object.assign({}, state, {
        hasServerError: false,
        errors: {},
        success: false,
      })
    case SERVER_ERROR_OCURED: 
      return Object.assign({}, state, {
        hasServerError: true,
        errors: action.errors,
        success: false
      })
    case REQUEST_TEMPLATES: 
      return Object.assign({}, state, {
        isFetchingTemplates: true,
        hasTemplateError: false,
        templateErrors: false,
      });
    case RECIEVE_TEMPLATES:
      return Object.assign({}, state, {
        isFetchingTemplates: false,
        templates: action.templates,
        templatesFecthed: true
      })
    case TEMPLATE_CLEAR_ERRORS:
      return Object.assign({}, state, {
        hasTemplateError: false,
        templateErrors: {},
        templatesFecthed: false
      });
    case TEMPLATE_SERVER_ERROR_OCCURED:
      return Object.assign({}, state, {
        hasTemplateError: true,
        templateErrors: action.errors,
        templatesFecthed: false
      })
    default:
      return state;
  }
};

export default questionnaireReducer;





// WEBPACK FOOTER //
// src/routes/Questionnaire/reducer.js